import { defineMessages } from 'react-intl';

export default defineMessages({
  newItemAdded: {
    id: 'shop.cart.newItemAddedMessage',
    defaultMessage: 'was added to your shopping cart.',
  },
});
